export default __webpack_public_path__ + "i18n/translations/translation-tr.531d7817.json";